import { FilterToolbarItem, FilterToolbarItemId } from 'src/components/Filters';
import { Content } from 'src/contexts/ContentContext';
import { Checkbox } from 'src/core/interim/Checkbox';
import { ContentId } from 'src/utils/constants/contentId';
import { PurchaseOrderState } from 'src/WebApiController';

type PurchaseOrderStateFilter = {
  purchaseOrderState: PurchaseOrderState | null;
};

export const usePurchaseOrderStateFilters = <
  TFilter extends PurchaseOrderStateFilter,
>({
  query,
  setQuery,
  isHorizontalLayout,
}: {
  query: TFilter;
  setQuery: (query: TFilter) => void;
  isHorizontalLayout?: boolean;
}): FilterToolbarItem => {
  return {
    filterId: 'purchaseOrderState' as FilterToolbarItemId,
    labelContentId: ContentId.ShowVoidCancelledPurchases,
    filterQueryKeys: ['purchaseOrderState'] as FilterToolbarItemId[],
    filterItem: (
      <Checkbox
        checked={query.purchaseOrderState !== PurchaseOrderState.Active}
        onChange={(e) => {
          const showCancelledAndVoided = e.target.checked;
          const newPurchaseOrderState = showCancelledAndVoided
            ? null
            : PurchaseOrderState.Active;

          if (newPurchaseOrderState !== query.purchaseOrderState) {
            setQuery({
              ...query,
              purchaseOrderState: newPurchaseOrderState,
            });
          }
        }}
        labelPosition="right"
        label={
          isHorizontalLayout ? undefined : (
            <Content id={ContentId.ShowVoidCancelledPurchases} />
          )
        }
      />
    ),
  };
};
